import * as snippet from '@segment/snippet'
import Script from 'next/script'

type ScriptSegmentProps = {
  segmentKey?: string
}

export function ScriptSegment({ segmentKey }: ScriptSegmentProps) {
  const options = {
    apiKey: segmentKey,
    page: false,
  }

  const segment = process.env.NEXT_PUBLIC_NODE_ENV
    ? snippet.max(options)
    : snippet.min(options)

  return (
    <Script
      dangerouslySetInnerHTML={{ __html: segment }}
      id={'segmentScript'}
    />
  )
}
